<div class="responsive-iframe-container">
  <button class="exit-button" (click)="closeDialog()">Exit</button>
  <iframe [src]="safeUrl" class="responsive-iframe"></iframe>
</div>